<template>
    <b-modal size="xl" id="barang-modal" :no-close-on-backdrop="true">
        <b-row>
            <b-col cols="12">
                <b-table
                    striped
                    hover
                    small
                    responsive
                    :fields="fields"
                    :items="barangs"
                    :per-page="perPage"
                    :current-page="currentPage"
                >
                    <template #head(checkbox)>
                        <b-form-checkbox v-model="allChecked"></b-form-checkbox>
                    </template>
                    <template #cell(checkbox)="{item}">
                        <b-form-checkbox v-if="item.stok > 0" :value="item" v-model="selectedBarangs"></b-form-checkbox>
                        <feather-icon v-else icon="SlashIcon" class="text-damger" />
                    </template>
                    <template #cell(harga)="{item}">
                        {{ formatRupiah(item.harga) }}
                    </template>
                    <template #cell(qty)="{item, index}">
                        <b-form-input
                            v-if="item.stok > 0"
                            :ref="'qtyBarang-' + index"
                            type="number"
                            v-model="item.qty"
                            class="w-75"
                            @keydown.up.native.prevent="moveQtyFocus(index, -1)"
                            @keydown.down.native.prevent="moveQtyFocus(index, 1)"
                        />
                        <i class="text-danger" v-else>Stok kosong</i>
                    </template>
                    <template #cell(stok)="{item}">
                        {{item.stok}} {{item.satuan ? item.satuan.satuan : ''}}
                    </template>
                    <template #cell(satuan)="{item}">
                        {{ item.satuan ? item.satuan.satuan : '-' }}
                    </template>
                </b-table>
            </b-col>
            <b-col cols="12">
                <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="center"
                size="sm"
                class="my-0"
                />
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button variant="warning" @click.prevent="chooseBarang">Pilih Barang</b-button>
        </template>
    </b-modal>    
</template>
<script>
import {BRow, BCol, BButton, BPagination, BFormGroup, BFormCheckbox, BFormInput, BTable} from 'bootstrap-vue'
import vSelect from 'vue-select'
import mixin from '../mixin'
export default {
    components: {
        BPagination,
        vSelect, BRow, BCol, BFormGroup, BFormCheckbox, BFormInput, BTable, BButton
    },
    mixins: [mixin],
    props: ['dataBarang'],
    data: () => ({
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        allChecked: false,
        ajuan: [],
        barangs: [],
        selectedBarangs: [],
        selectedAjuan: null,
        fields: [
            { key: 'checkbox', label: 'No' },
            { key: 'nama', label: 'Barang' },
            { key: 'harga', label: 'Harga' },
            { key: 'stok', label: 'Stok Mobil' },
            { key: 'qty', label: 'Jumlah' },
            { key: 'satuan', label: 'Satuan' },
        ]
    }),
    watch: {
        allChecked(val) {
            const availableBarangs = this.barangs.filter(item => item.stok > 0)
            if(val && availableBarangs.length > 0) {
                this.selectedBarangs = this.barangs
            }
            else {
                this.selectedBarangs = []
            }
        },
        dataBarang(val) {
            if(val) {
                this.barangs = val
                this.totalRows = val.length
            }
        }
    },
    created() {
        if(this.dataBarang) {
            this.totalRows = this.dataBarang.length
        }
    },
    methods: {
        moveQtyFocus(fromIndex, direction) {
            let nextIndex = fromIndex + direction
            const maxIndex = this.perPage || 10
            this.$nextTick(() => {
                while (nextIndex >= 0 && nextIndex < maxIndex) {
                    const ref = this.$refs['qtyBarang-' + nextIndex]
                    const el = Array.isArray(ref) ? ref[0] : ref
                    if (!el) {
                        nextIndex += direction
                        continue
                    }
                    const input = el.$el ? el.$el.querySelector('input') || el.$el : el
                    if (input && typeof input.focus === 'function') {
                        input.focus()
                        if (typeof input.select === 'function') {
                            input.select()
                        }
                    }
                    return
                }
            })
        },
        chooseBarang() {
            this.selectedBarangs.map(barang => {
                // qty tetap satuan dasar (pcs) — tanpa konversi
                barang.old_qty = barang.qty
                barang.diskon = 0
            })
            this.$emit('selected-barang', this.selectedBarangs)
            this.$bvModal.hide('barang-modal')
        },
    }
}
</script>
